module.exports = __webpack_public_path__ + "img/google.a6adc178.png";